import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import { string, object } from 'prop-types';
import styled from 'styled-components';

const EulaBodyStyle = styled.div`
	width: 100%;
	height: 325px;
	padding-bottom: 50px;
	.ScrollbarsCustom-Track {
		right: -15px !important;
		top: 0px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.account} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 300px;
		padding-bottom: 100px;
		.ScrollbarsCustom-Track {
			right: -15px !important;
			top: 0px !important;
		}

		.ScrollbarsCustom-ThumbY {
			width: 8px !important;
		}
		.ScrollbarsCustom-TrackY {
			width: 8px !important;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 460px;
		padding-bottom: 100px;
		.ScrollbarsCustom-Track {
			right: -15px !important;
			top: 0px !important;
		}

		.ScrollbarsCustom-ThumbY {
			width: 10px !important;
		}
		.ScrollbarsCustom-TrackY {
			width: 10px !important;
		}
	}
`;

export const EulaBody = ({ id, cypressId, hasReachedBottom, eula }) => {
	function hasReachedBottomScroll(value) {
		if (value) {
			hasReachedBottom(value);
		}
	}

	return (
		<EulaBodyStyle id={id} className='' data-cy={cypressId}>
			<ScrollView hasReachedBottom={hasReachedBottomScroll}>
				{eula && <div className='eula-details body10'>{ReactHtmlParser(eula)}</div>}
			</ScrollView>
		</EulaBodyStyle>
	);
};

EulaBody.propTypes = {
	id: string,
	cypressId: string,
	eula: object,
};

EulaBody.defaultProps = {
	id: 'eula-modal-body',
	cypressId: 'eula-modal-body',
	eula: null,
};
